import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import LiveFloorViewApi from '../../api/livefloorview';
import { setAuthorise } from '../../redux/actions/installations';
import LiveFloorViewDetailsModal from '../modals/LiveFloorViewDetailsModal';
import DataGrid from '../shared/DataGrid';
import MachineStatusFilters from './MachineStatusFilters';
import StatusLabels from '../shared/StatusLabels';
import { mapStatuses } from '../../helpers/liveFloor';
import RefreshSlider from '../shared/RefreshSlider';
import { showLiveFloorViewDetailsModal } from '../../redux/actions/modals';

class SiteControllerTab extends React.Component {
  state = {
    statuses: {
      onlineEFTEnabled: false,
      offlineSiteOpen: true,   
      pending: false,
      authReq: true,
      offlineSiteClosed: false,
      onlineEFTDisabled: false,
      onlineNoFunds: false,
    },
    quantities: {
      onlineQty: 0,
      onlineEFTEnabledQty: 0,
      offlineSiteOpenQty: 0,
      pendingQty: 0,
      authReqQty: 0,
      offlineSiteClosedQty: 0,
      unknownQty: 0,
      onlineEFTDisabledQty: 0,
      onlineNoFundsQty: 0,
    },
    grid: {
      rowDef: [],
      headerDef: [],
      data: []
    },
    authorise: false,
    loading: false,
    timerId: 0,
    currentInstallation: { installationId: null, optionShowPopup: false },
  };

  handleCommsViewSelection = currentInstallation => this.setState({ currentInstallation }, () => this.props.showLiveFloorViewDetailsModal(currentInstallation));

  handleStatusChange = (key, value) => {
    let statuses = {...this.state.statuses};
    statuses[key]=!statuses[key];
    this.setState({ statuses });
  }

  handleRefresh = () => {

  }

  componentWillUnmount() {
    clearInterval(this.state.timerId);
  }

  render() {
    const { statuses, quantities, loading } = this.state;
    const labels = mapStatuses(statuses, quantities);
    const disabled = !this.props.filters.filterSelected.operator ;
    return (
      <Grid relaxed className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="16">
            <StatusLabels
              labels={labels}
              onClick={this.handleStatusChange}
            />
            <RefreshSlider refresh={this.handleRefresh} disabled={disabled} loading={loading} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <DataGrid
              loading={this.state.loading}
              headings={this.state.grid.headerDef}
              rowDef={this.state.grid.rowDef}
              data={this.state.grid.data}
              onRowClick={this.handleCommsViewSelection}
              fullHeight
            />

          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};

const mapStateToProps = state => {
	return {
    filters: state.LiveFloorViewerFilters,
  };
};

export default connect(mapStateToProps, { showLiveFloorViewDetailsModal, setAuthorise })(SiteControllerTab);

